export enum FormId {
  UserInfo = 'userInfo',
  OptIn = 'optIn',
}
